import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state={   //要设置的全局访问的state对象
    groupLogo:'',
    copyright:'',
    icpRecord: '',
    policeRecord: '',
    policeRecordNumber: ''
    //要设置的初始属性值
  };
const getters = {   //实时监听state值的变化(最新状态)
   getGroupLogo(state) {  //方法名随意,主要是来承载变化的值
      return state.groupLogo
   },
   getCopyright(){  //方法名随意,主要是用来承载变化的值
      return state.copyright
   },
   getIcpRecord(){
      return state.icpRecord
   },
   getPoliceRecord(){
      return state.policeRecord
   },
   getPoliceRecordNumber(){
      return state.policeRecordNumber
   },
};
const mutations = {
    groupLogo(state,logo){ //同上，这里面的参数除了state之外还传了需要增加的值logo
       state.groupLogo=logo;
    },
    copyright(state,copyright){ //同上，这里面的参数除了state之外还传了需要增加的值logo
        state.copyright=copyright;
    },
    icpRecord(state,icpRecord){ //同上，这里面的参数除了state之外还传了需要增加的值logo
        state.icpRecord=icpRecord;
    },
    policeRecord(state,policeRecord){ //同上，这里面的参数除了state之外还传了需要增加的值logo
        state.policeRecord=policeRecord;
    },
    policeRecordNumber(state,policeRecordNumber){ //同上，这里面的参数除了state之外还传了需要增加的值logo
        state.policeRecordNumber=policeRecordNumber;
    },
};
const actions = {
    setGroupLogo(context,logo){   //同上注释，num为要变化的形参
        context.commit('groupLogo',logo)
    },
    setCopyright(context,copyright){   //同上注释，num为要变化的形参
        context.commit('copyright',copyright)
    },
    setIcpRecord(context,icpRecord){   //同上注释，num为要变化的形参
        context.commit('icpRecord',icpRecord)
    },
    setPoliceRecord(context,policeRecord){   //同上注释，num为要变化的形参
        context.commit('policeRecord',policeRecord)
    },
    setPoliceRecordNumber(context,policeRecordNumber){   //同上注释，num为要变化的形参
        context.commit('policeRecordNumber',policeRecordNumber)
    },
};
const store = new Vuex.Store({
      state,
      getters,
      mutations,
      actions
});
 
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js